import React from 'react'

import InternalLayout from 'components/layouts/InternalLayout'
import ProtectedRoute from 'components/routes/ProtectedRoute'

function InternalRoute(props) {
  return (
    <ProtectedRoute
      layout={InternalLayout}
      requiredSessionState={ProtectedRoute.sessionStates.LOGGED_IN}
      {...props}
    />
  )
}

export default InternalRoute
